define('home/models/AnonUser',[
    'core/models/BaseUser',

    'home/utils/navigationUtils',
], function (
    BaseUser,

    navigationUtils
) {
    'use strict';

    var AnonUser = BaseUser.extend({
        initialize: function () {
            this.listenTo(this, 'followed:user', this.promptLogin);
            this.listenTo(this, 'unfollowed:user', this.promptLogin);
            this.listenTo(this, 'followed:forum', this.promptLogin);
            this.listenTo(this, 'unfollowed:forum', this.promptLogin);
            this.listenTo(this, 'followed:channel', this.promptLogin);
            this.listenTo(this, 'unfollowed:channel', this.promptLogin);
            this.listenTo(this, 'subscribe:thread', this.promptLogin);
            this.listenTo(this, 'unsubscribe:thread', this.promptLogin);
        },

        promptLogin: function () {
            navigationUtils.navigateToLogin();
        },

        isGlobalAdmin: function () {
            return false;
        },
    });

    return (function () {
        var _anonUser;

        return function () {
            if (!_anonUser)
                _anonUser = new AnonUser();

            return _anonUser;
        };
    })();
});

